export default {"src":"/_next/static/media/settings.2cbd99e9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};